"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WIZARD_PAGE_MESSAGE_TYPE = void 0;
// Dominik; 07.09.2022; there is a discrepancy between PageType and WIZARD_PAGE_MESSAGE_TYPE because the select message
// is split in two types; IMO this should be fixed and is a code smell
const WIZARD_PAGE_MESSAGE_TYPE = exports.WIZARD_PAGE_MESSAGE_TYPE = ['select', 'products', 'gallery', 'image', 'input', 'range', 'text', 'video', 'file_upload', 'multiple_input'];